(() => {
  if (window.WebbFooterBackToTopInitialized) return;
  window.WebbFooterBackToTopInitialized = true;

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-webb-back-to-top]');
    if (!trigger) return;

    event.preventDefault();
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, left: 0, behavior: reduceMotion ? 'auto' : 'smooth' });

    if (window.location.hash) {
      window.history.replaceState(null, '', `${window.location.pathname}${window.location.search}`);
    }
  });
})();
